import React from 'react';

import { RecursiveMenu } from '@uncinc/react-drupal-core';
import type { RecursiveMenuProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import { useMegaMenuContext } from '../../../context/MegaMenuContext';
import MegaMenuSubMenuItemLinkElement from './ItemLinkElement';
import MegaMenuSubMenuItemWrapper from './ItemWrapper';

import './style.scss';

export type MegaMenuSubMenuProps = Pick<RecursiveMenuProps, 'maxLevel'>;

const MegaMenuSubMenu: React.FC<MegaMenuSubMenuProps> = ({ maxLevel }) => {
  const { menuId, updateExpandedMenuItem } = useMegaMenuContext();

  return (
    <div className="MegaMenu__SubMenu">
      <RecursiveMenu
        menuId={menuId}
        minLevel={1}
        maxLevel={maxLevel}
        onClickFunction={() => updateExpandedMenuItem('')}
        MenuItemWrapper={MegaMenuSubMenuItemWrapper}
        MenuItemLinkElement={MegaMenuSubMenuItemLinkElement}
      />
    </div>
  );
};

export default MegaMenuSubMenu;
